export class UpsellItem {
    id: number;
    quantity: number;
}
